import API from 'services/api';
import { getRegionId } from 'reducers/users';
import { errorHandler } from 'utils/errorMessages';
import { setLoading, showSnackbar, toggleModal } from 'reducers/ui';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { get, isEmpty } from 'lodash';
import {
  zoneActions,
  zoneFilterActions,
  zoneNameSpace,
  zoneSelectors,
} from 'containers/Pages/Locations/Zones';

export function* fetchZoneListSaga({ payload }) {
  const { filters, from, fetchAll } = payload;

  try {
    yield put(setLoading(true));
    const regionId = yield select(getRegionId);
    const filterKeyStatus = yield select(zoneSelectors.getZoneFilterKey);
    const forceRefresh = yield select(zoneSelectors.getForceRefresh);
    const getZoneList = yield select(zoneSelectors.getZoneListRaw);
    // if firebase sends a notification or workOrderList is empty or filter key is pressed or pagination is increased
    if (
      isEmpty(getZoneList) ||
      forceRefresh ||
      filterKeyStatus ||
      (from === 0 && !isEmpty(getZoneList)) ||
      (from > 0 && !isEmpty(getZoneList))
    ) {
      const { data } = yield call(API.fetchZoneList, {
        regionId,
        from,
        fetchAll,
        ...filters,
      });
      if (data.data != null) {
        const totalEntries = get(data, 'meta.total');
        yield put(
          zoneActions.setGridList({
            list: data.data,
            totalEntries,
          }),
        );
      }
    }
    yield put(zoneFilterActions.setFilterKey(false));
    yield put(zoneActions.setForceRefresh(false));
  } catch (err) {
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(err),
      }),
    );
  }
  yield put(setLoading(false));
}

export function* fetchZoneDetailsSaga({ payload }) {
  try {
    const { data } = yield call(API.fetchZoneDetails, payload);
    if (data.data != null) {
      yield put(zoneActions.setGridRowDetails({ details: data.data }));
    }
  } catch (err) {
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(err),
      }),
    );
  }
}
export function* createZoneSaga({ payload }) {
  const { zone } = payload;
  try {
    yield put(setLoading(true));
    yield call(API.createZone, zone);
    yield put(toggleModal(zoneNameSpace));
    yield put(setLoading(false));
  } catch (err) {
    yield put(setLoading(false));
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(err),
      }),
    );
  }
}

export function* updateZoneSaga({ payload }) {
  const { id, zone } = payload;
  try {
    yield put(setLoading(true));
    const { status } = yield call(API.updateZone, id, zone);

    if (status === 200) {
      yield call(zoneActions.fetchGridRowDetails, { payload: id });
    }

    yield put(toggleModal(zoneNameSpace));
    yield put(setLoading(false));
  } catch (err) {
    yield put(setLoading(false));
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(err),
      }),
    );
  }
}
export function* zoneSagas() {
  yield takeLatest(zoneActions.fetchGridList, fetchZoneListSaga);
  yield takeLatest(zoneActions.fetchGridRowDetails, fetchZoneDetailsSaga);
  yield takeLatest(zoneActions.createRowEntry, createZoneSaga);
  yield takeLatest(zoneActions.updateRowEntry, updateZoneSaga);
}
